import { render, staticRenderFns } from "./SignatureVerificationDialog.vue?vue&type=template&id=41c24d1c&scoped=true&"
import script from "./SignatureVerificationDialog.vue?vue&type=script&lang=js&"
export * from "./SignatureVerificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./SignatureVerificationDialog.vue?vue&type=style&index=0&id=41c24d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c24d1c",
  null
  
)

export default component.exports